import { useState } from "react";
import { Check, Copy } from "lucide-react";

/** Reference material: the verbatim prompt, the sphere build spec and the category order. */
export const SpecPanel = ({ canon }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(canon?.canonical_prompt || "");
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="space-y-12" data-testid="admin-spec-panel">
      <section>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="label">Feed this verbatim to any model · {canon?.spec_version}</p>
          <button
            onClick={copy}
            data-testid="admin-copy-prompt-btn"
            className="btn-stark flex items-center gap-2"
          >
            {copied ? <Check size={11} /> : <Copy size={11} />}
            {copied ? "Copied" : "Copy prompt"}
          </button>
        </div>
        <pre
          data-testid="admin-canonical-prompt-block"
          className="thin-scroll mt-5 max-h-[32rem] overflow-auto border border-[var(--line)] bg-[#0a0a0d] p-5 font-data text-[11px] leading-relaxed text-zinc-300"
        >
          {canon?.canonical_prompt || "loading…"}
        </pre>
      </section>

      <section>
        <p className="label">How the sphere is built (reproducible)</p>
        <pre className="thin-scroll mt-4 max-h-96 overflow-auto border border-[var(--line)] bg-[#0a0a0d] p-5 font-data text-[11px] leading-relaxed text-zinc-300">
          {JSON.stringify(canon?.sphere_build_spec, null, 2)}
        </pre>
      </section>

      <section>
        <p className="label">
          {canon?.categories?.length ?? 46} categories · fixed order drives geometry
        </p>
        <pre className="thin-scroll mt-4 max-h-96 overflow-auto border border-[var(--line)] bg-[#0a0a0d] p-5 font-data text-[11px] leading-relaxed text-zinc-300">
          {JSON.stringify(canon?.categories, null, 2)}
        </pre>
      </section>
    </div>
  );
};

export default SpecPanel;
